import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { EFCategory } from './efCategory.model';


@Injectable({
  providedIn: 'root'
})
export class EfcategoryService {

  constructor(private http: HttpClient, private global: Globle) {
  }


  getAll(status: number) {
    return this.http.get<EFCategory[]>(this.global.APIURLV2 + "efcategory/get?status=" + status);
  }

  getById(id: number) {
    return this.http.get<EFCategory>(this.global.APIURLV2 + "efcategory/getbyid/" + id);
  }

  Update(category: EFCategory) {
    return this.http.put(this.global.APIURLV2 + "efcategory/update", category)
  }
}
